import {nsFetch} from "/assets/js/utils/fetch";
import { UrlManager } from '../utils/UrlManager';

class Catalog {
    mainContainer;
    productsContainer;
    productsCounter;
    resetBtn;
    applyBtn;
    filterTags;
    filterCategories;
    sortDropdown;
    sortDropdownInput;
    priceMin;
    priceMax;
    moreBtn;
    paginationContainer;
    paginationBtns;
    pageTitle;
    curPage;
    baseUrl;
    baseTaxId;
    baseTaxType;

    urlManager;

    constructor(elm) {
        this.pageTitle = document.querySelector('.catalog-page__title');
        this.mainContainer = elm;
        this.productsContainer = this.mainContainer.querySelector('.catalog-page__content-products-body');
        this.productsCounter = this.mainContainer.querySelector('.catalog-page__content-products-head-title');

        this.resetBtn = this.mainContainer.querySelector('.catalog-page__content-filter-head-reset');
        this.applyBtn = this.mainContainer.querySelector('.catalog-page__content-filter-btn');
        this.filterTags = this.mainContainer.querySelectorAll('.filter-tags input[type="checkbox"]');
        this.filterCategories = this.mainContainer.querySelectorAll('.filter-categories input[type="checkbox"]');
        this.moreBtn = this.mainContainer.querySelector('.catalog-page__content-products-btn-more');
        this.paginationContainer = this.mainContainer.querySelector('.pagination-container');

        this.sortDropdownInput = this.mainContainer.querySelector('#dropdownInput');
        this.sortDropdown = this.mainContainer.querySelector('[data-dropdown]');
        this.priceMin = this.mainContainer.querySelector('[name="price_min"]');
        this.priceMax = this.mainContainer.querySelector('[name="price_max"]');

        this.urlManager = new UrlManager();
        this.baseUrl = this.mainContainer.dataset.baseUrl;
        this.baseTaxId = this.mainContainer.dataset.baseTaxId;
        this.baseTaxType = this.mainContainer.dataset.baseTaxType;
        this.baseSearchQuery = this.mainContainer.dataset.baseSearchQuery || '';
        this.paginationBase = this.mainContainer.dataset.paginationBase || 'page';
        this.prettyPermalinks = this.mainContainer.dataset.prettyPermalinks !== '0';
        this.curPage = this.mainContainer.dataset.paged;
        this.loadedPage = this.curPage;

        this.init();
        this.initPagination();
        // A history entry can have another archive context and SEO metadata.
        window.addEventListener('popstate', () => window.location.reload());
    }

    init() {
        if (this.sortDropdown) {
            this.sortDropdown.addEventListener('dropdown:change', this.sortChanged);
        }
        if (this.resetBtn) {
            this.resetBtn.addEventListener('click', this.resetFilter);
        }
        if (this.applyBtn) {
            this.applyBtn.addEventListener('click', this.applyFilter);
        }
        if (this.moreBtn) {
            this.moreBtn.addEventListener('click', this.loadMore);
        }
    }

    initPagination() {
        if (!this.paginationContainer) return;
        this.paginationBtns = this.paginationContainer.querySelectorAll('.page-button');
        this.paginationBtns.forEach(elm => elm.addEventListener('click', this._clickPageBtn));
    }

    loadMore = async (e) => {
        e.preventDefault();

        ++this.curPage;
        const filterData = this.getFilterData();

        await this.requestFilter(filterData, true, true);
    }

    _clickPageBtn = async (e) => {
        e.preventDefault();

        const btn = e.target.closest('.page-button');

        if (btn.classList.contains('catalog-page__content-products-pagination-prev')) {
            --this.curPage;
        } else if (btn.classList.contains('catalog-page__content-products-pagination-next')) {
            ++this.curPage;
        } else {
            this.curPage = btn.dataset.page;
        }

        const filterData = this.getFilterData();

        await this.requestFilter(filterData, true);

        this.scrollToTop();
    }

    showPreloader() {
        if (!this.productsContainer) return;
        
        // Проверяем, не добавлен ли уже прелоадер
        if (this.productsContainer.querySelector('.catalog-page__content-products-loading')) {
            return;
        }
        
        this.productsContainer.classList.add('is-loading');
        
        // Создаем overlay с прелоадером
        const loadingOverlay = document.createElement('div');
        loadingOverlay.className = 'catalog-page__content-products-loading';
        
        this.productsContainer.appendChild(loadingOverlay);
    }

    hidePreloader() {
        if (!this.productsContainer) return;
        this.productsContainer.classList.remove('is-loading');
        
        // Удаляем прелоадер, если он есть
        const loadingOverlay = this.productsContainer.querySelector('.catalog-page__content-products-loading');
        if (loadingOverlay) {
            loadingOverlay.remove();
        }
    }

    async requestFilter(filterData, clickPage = false, loadMore = false) {
        if (!clickPage) this.curPage = 1;
        const requestId = this.requestId = (this.requestId || 0) + 1;
        //console.log(this.mainContainer.dataset);
        
        // Показываем прелоадер при любой загрузке
        this.showPreloader();
        
        const body = {
            'filter_data': filterData,
            'paged': this.curPage,
            'base_tax_id': this.baseTaxId,
            'base_tax_type': this.baseTaxType,
            'base_url': this.baseUrl,
            'url_params': Object.fromEntries(this.getUrlParams()),
            'click_page': clickPage
        };
        if (this.baseTaxType === 'search' && this.baseSearchQuery) {
            body.search_query = this.baseSearchQuery;
        }
        const response = await nsFetch.doFetch({
            action: 'ns_filter_catalog',
            body
        });

        // Скрываем прелоадер
        if (requestId !== this.requestId) return;
        this.hidePreloader();

        if (!response || !response.success) {
            this.curPage = this.loadedPage;
            notice(
                response?.data?.message || 'Не удалось загрузить товары. Попробуйте ещё раз.',
                'error'
            );
            
        } else {
            this.loadedPage = this.curPage;
            this.updateUrl(filterData);
            this.productsCounter.innerHTML = response.data.total_html;

            if (loadMore) {
                this.productsContainer.innerHTML += response.data.products_html;
            } else {
                this.productsContainer.innerHTML = response.data.products_html;
            }
            this.paginationContainer.innerHTML = response.data.pagination_html;

            // Скрываем кнопку, если нет товаров или нет следующих страниц
            if (this.moreBtn) {
                if (response.data.total === 0 || (response.data.pagination_html == '') || response.data.total_pages <= this.curPage) {
                    this.moreBtn.classList.add('is-hidden');
                } else {
                    this.moreBtn.classList.remove('is-hidden');
                }
            }

            this.initPagination();
            
            // Переинициализируем обработчики кликов на каунтер после обновления товаров
            if (window.cartInstance) {
                window.cartInstance.reinit();
            }
            
            // Скроллим вверх к фильтру с сеткой товаров после фильтрации (но не при loadMore)
            if (!loadMore) {
                this.scrollToProductsGrid();
            }
        }
    }

    sortChanged = async (e) => {
        const filterData = this.getFilterData();
        await this.requestFilter(filterData);
    }

    resetFilter = (e) => {
        e.preventDefault();
        if (!this.resetBtn || !this.filterTags || !this.filterCategories) return;

        this.filterTags.forEach(elm => {
            elm.checked = false;
        });

        this.filterCategories.forEach(elm => {
            elm.checked = false;
        });

        this.resetBtn.classList.add('is-hidden');

        const url = new URL(this.baseUrl, window.location.origin);
        const orderby = this.sortDropdownInput?.value;
        if (orderby && orderby !== 'menu_order') url.searchParams.set('orderby', orderby);
        window.location.href = url.href;
    }

    applyFilter = async (e) => {
        e.preventDefault();
        if (!this.applyBtn) return;

        // Добавляем прелоадер
        this.applyBtn.classList.add('is-loading');

        try {
            const filterData = this.getFilterData();

            await this.requestFilter({
                'f_tags': filterData.f_tags,
                'f_cats': filterData.f_cats,
                'f_price': filterData.f_price,
                'orderby': filterData.orderby
            });

            this.resetBtn.classList.toggle('is-hidden', !(
                (filterData.f_tags != '') ||
                (filterData.f_cats != '') ||
                (filterData.f_price != '')
            ));

            if (this.applyBtn.classList.contains('is-mobile')) {
                const filterModal = document.getElementById("filter-modal");
                this.closeMblFilter(filterModal);
            }
        } finally {
            // Убираем прелоадер
            if (this.applyBtn) {
                this.applyBtn.classList.remove('is-loading');
            }
        }
    }

    closeMblFilter(filterModal) {
        const closeEvent = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
        });
        filterModal.dispatchEvent(closeEvent);
    }

    getFilterData() {
        return {
            'f_tags': this.getSelectedFilterItemValues(this.filterTags),
            'f_cats': this.getSelectedFilterItemValues(this.filterCategories),
            'f_price': this.getSelectedFilterPriceValues(),
            'orderby': this.sortDropdownInput?.value || 'menu_order'
        }
    }

    getSelectedFilterPriceValues() {
        if (!this.priceMin || !this.priceMax) return '';
        if ((this.priceMin.value != this.priceMin.min) || (this.priceMax.value != this.priceMax.max)) {
            return this.priceMin.value + ',' + this.priceMax.value;
        } else {
            return '';
        }
    }

    getSelectedFilterItemValues(elements) {
        return Array.from(elements)
            .filter(elm => elm.checked)
            .map(elm => elm.value)
            .join(',');
    }

    updateUrl(filterData) {
        if (Object.prototype.hasOwnProperty.call(filterData, 'f_cats')) {
            filterData = { ...filterData, f_cats: this.normalizeCategoryIds(filterData.f_cats) };
        }
        // PHP supplies real permalinks; AJAX still queries the root section.
        const category = ['product_cat', 'shop'].includes(this.baseTaxType) && /^[1-9][0-9]*$/.test(filterData.f_cats || '')
            ? Array.from(this.filterCategories || []).find(input => input.value === filterData.f_cats && input.dataset.categoryUrl)
            : null;
        const url = new URL(category ? category.dataset.categoryUrl : this.baseUrl, window.location.origin);
        // Keep unrelated query parameters while replacing catalogue state atomically.
        this.getUrlParams().forEach((value, key) => url.searchParams.set(key, value));
        for (const [param, value] of Object.entries(filterData)) {
            if (value !== '' && !(param === 'orderby' && value === 'menu_order')) {
                url.searchParams.set(param, value);
            } else {
                url.searchParams.delete(param);
            }
        }
        // Remove even an f_cats inherited from the URL before this action.
        if (url.searchParams.has('f_cats')) url.searchParams.set('f_cats', this.normalizeCategoryIds(url.searchParams.get('f_cats')));
        if (category) url.searchParams.delete('f_cats');
        this.setUrlPage(url, this.curPage, Boolean(category));
        if (url.href !== window.location.href) this.urlManager.setUrl(url.href);
    }

    getUrlParams() {
        const params = new URL(window.location.href).searchParams;
        for (const key of ['paged', 'page', 'wc-ajax', 'add-to-cart', 'product_cat', 'product', 'taxonomy', 'term', 'post_type', 'name', 'p', 'page_id', 'pagename', 'attachment', 'attachment_id', 'error', 'ns_catalog_route', 's', 'search', 'feed', 'preview', 'preview_id', 'preview_nonce', 'rest_route']) params.delete(key);
        return params;
    }

    normalizeCategoryIds(value) {
        if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return '0';
        value = String(value);
        if (value.trim() !== value || !/^[1-9][0-9]*(,[1-9][0-9]*)*$/.test(value)) return value;
        return [...new Set(value.split(','))]
            .sort((a, b) => a.length - b.length || (a < b ? -1 : a > b ? 1 : 0))
            .join(',');
    }

    setUrlPage(url, page, canonicalCategory = false) {
        const paginationBase = this.paginationBase || 'page';
        const suffix = url.pathname.split('/').filter(Boolean);
        if (!canonicalCategory && suffix.length >= 2 && suffix[suffix.length - 2] === paginationBase && /^[0-9]+$/.test(suffix[suffix.length - 1])) {
            suffix.splice(-2);
            url.pathname = '/' + (suffix.length ? suffix.join('/') + '/' : '');
        }
        url.searchParams.delete('paged');
        if (Number(page) <= 1) return;
        if (this.baseTaxType !== 'search' && this.prettyPermalinks !== false) {
            url.pathname = url.pathname.replace(/\/$/, '') + '/' + paginationBase + '/' + Number(page) + '/';
        } else {
            url.searchParams.set('paged', page);
        }
    }

    scrollToTop = () => {
        const header = document.querySelector('header.header');
        const offsetY = header.getBoundingClientRect().height; 
        const position = this.pageTitle.getBoundingClientRect().top + window.scrollY - offsetY;

        window.scrollTo({ top: position, behavior: "smooth" });
    }

    scrollToProductsGrid = () => {
        // Находим контейнер с фильтром и сеткой товаров
        const productsSection = this.mainContainer.querySelector('.catalog-page__content');
        if (!productsSection) return;
        
        const header = document.querySelector('header.header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const position = productsSection.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

        window.scrollTo({ top: position, behavior: "smooth" });
    }


}

document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.catalog-page');
    if (elm) {
        new Catalog(elm);
    }
});

